import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FloatingButtons from '@/components/feature/FloatingButtons';
import LocationHero from './components/LocationHero';
import ContactInfo from './components/ContactInfo';
import MapCard from './components/MapCard';
import QuickActions from './components/QuickActions';
import ServiceArea from './components/ServiceArea';
import { db } from '@/lib/firebase';
import { doc, getDoc, onSnapshot } from 'firebase/firestore';

export default function LocationPage() {
  const [images, setImages] = useState<any>({});

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Location & Contact | Bucara Burger – Colombian Food Truck Boise Idaho';

    const unsubImages = onSnapshot(doc(db, 'settings', 'landing_images'), (docSnap) => {
      if (docSnap.exists()) {
        setImages(docSnap.data());
      }
    });

    return () => unsubImages();
  }, []);

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Local SEO structured data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FoodEstablishment',
            name: 'Bucara Burger',
            description: 'Colombian food truck in Boise Idaho serving gourmet burgers, Colombian hot dogs, empanadas, arepas, and natural juices.',
            url: 'https://bucaraburger.com',
            telephone: '+19862173604',
            servesCuisine: ['Colombian', 'Latin American', 'Fast Food'],
            priceRange: '$',
            address: {
              '@type': 'PostalAddress',
              streetAddress: '1630 Broadway Ave',
              addressLocality: 'Boise',
              addressRegion: 'ID',
              postalCode: '83706',
              addressCountry: 'US',
            },
            geo: {
              '@type': 'GeoCoordinates',
              latitude: 43.6,
              longitude: -116.2,
            },
            openingHoursSpecification: [
              { '@type': 'OpeningHoursSpecification', dayOfWeek: 'Tuesday', opens: '11:00', closes: '21:00' },
              { '@type': 'OpeningHoursSpecification', dayOfWeek: 'Wednesday', opens: '11:00', closes: '21:00' },
              { '@type': 'OpeningHoursSpecification', dayOfWeek: 'Thursday', opens: '11:00', closes: '21:00' },
              { '@type': 'OpeningHoursSpecification', dayOfWeek: 'Friday', opens: '11:00', closes: '22:00' },
              { '@type': 'OpeningHoursSpecification', dayOfWeek: 'Saturday', opens: '10:00', closes: '22:00' },
              { '@type': 'OpeningHoursSpecification', dayOfWeek: 'Sunday', opens: '10:00', closes: '20:00' },
            ],
            sameAs: [
              'https://instagram.com/bucara__burger',
              'https://www.facebook.com/profile.php?id=61589000696717',
              'https://tiktok.com/@bucara__burger',
            ],
            areaServed: ['Boise', 'Meridian', 'Nampa', 'Caldwell', 'Kuna', 'Eagle', 'Middleton', 'Star'],
          }),
        }}
      />

      <Navbar />
      <LocationHero image={images?.locationHeroImage} />

      {/* Main 2-column layout */}
      <main className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
          {/* Left: Contact Info */}
          <ContactInfo />
          {/* Right: Map */}
          <MapCard />
        </div>
      </main>

      {/* Quick action buttons */}
      <QuickActions />

      {/* Service area trust section */}
      <ServiceArea image={images?.locationServiceAreaImage} />

      <Footer />
      <FloatingButtons />
    </div>
  );
}
